module.exports = __webpack_public_path__ + "static/media/confirm_fig.807e33eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/confirm_fig.svg
// module id = 1639
// module chunks = 0